var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-image-hero" }, [
    _vm.imgType == "is-large"
      ? _c("div", { staticClass: "c-image-hero__top" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "img-container" }, [
              _c("div", {
                directives: [
                  {
                    name: "lazy",
                    rawName: "v-lazy:background-image",
                    value: _vm.image.top,
                    expression: "image.top",
                    arg: "background-image"
                  }
                ],
                staticClass: "img"
              }),
              _vm._m(0)
            ])
          ])
        ])
      : _vm.imgType == "is-medium"
      ? _c("div", { staticClass: "c-image-hero__inside" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "img-container" }, [
              _c("div", {
                directives: [
                  {
                    name: "lazy",
                    rawName: "v-lazy:background-image",
                    value: _vm.image.inside,
                    expression: "image.inside",
                    arg: "background-image"
                  }
                ],
                staticClass: "img"
              }),
              _vm._m(1)
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-image-hero__loading" }, [
      _c("div", { staticClass: "ball-beat" }, [_c("div"), _c("div"), _c("div")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-image-hero__loading" }, [
      _c("div", { staticClass: "ball-beat" }, [_c("div"), _c("div"), _c("div")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }